<template>
    <div>

        <!-- Flat view button -->

        <a :href="location+'/flat'" class="btn btn-white btn-sm mb-4">
            <i class="material-icons" style="position:relative;top:-1px;margin-right:5px;">list</i>
            {{ lang.polaris.dashboard.flat_view }}
        </a>

        <!-- Signatures button -->

        <a :href="location+'/signatures'" class="btn btn-white btn-sm mb-4">
            <i class="material-icons" style="position:relative;top:-1px;margin-right:5px;">fingerprint</i>
            {{ lang.polaris.dashboard.signatures }}
        </a>

        <!-- Customize button -->

        <a :href="location+'/custom'" class="btn btn-white btn-sm mb-4" v-if="customPermission && customStatus">
            <i class="material-icons" style="position:relative;top:-1px;margin-right:5px;">grid_on</i>
            {{ lang.polaris.dashboard.customize }}
        </a>

        <!-- Struct -->

        <enac-atpl-dashboard-phase-learner-items-map :id="id" :bus="bus">
        </enac-atpl-dashboard-phase-learner-items-map>

        <!-- Details modal -->

        <trax-ui-modal-plain-header :id="id+'-details'" :bus="bus">
            <enac-atpl-dashboard-phase-learner-item-details :id="id+'-details'" :bus="bus">
            </enac-atpl-dashboard-phase-learner-item-details>
        </trax-ui-modal-plain-header>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-phase-learner-items'}
        },
    
        data: function() {
            return {
                lang: lang,
                user: user,
                registration: data.registration,
                location: window.location,
                bus: new Vue()
            }
        },

        computed: {

            customPermission: function() {
                return this.user.admin || this.user.permissions['dashboard.customize-phases']
                     || this.user.permissions['dashboard.customize-individual-path'] 
            },

            customStatus: function() {
                return this.registration.status != 'archived';
            }
        }
    }
</script>
